module.exports = __webpack_public_path__ + "static/img/xls.b1667672.png";